<div class="cfg-dialog">

  <div class="cfg-header" mat-dialog-title>
    <div class="cfg-title">
      <mat-icon>tune</mat-icon>
      <div>
        <h2>Configuraciones</h2>
        <span class="cfg-sub">{{ data.identifier || 'Equipo' }}</span>
      </div>
    </div>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <mat-dialog-content class="cfg-body">

    @if (rows().length === 0) {
      <div class="cfg-empty">
        <mat-icon>playlist_add</mat-icon>
        <p>Aún no hay configuraciones. Agrega una para empezar.</p>
      </div>
    }

    @for (row of rows(); track $index) {
      <div class="cfg-card">
        <div class="cfg-card-head">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="name-field">
            <mat-label>Nombre</mat-label>
            <input matInput required [value]="row.name"
                   (input)="patch($index, 'name', $any($event.target).value)">
          </mat-form-field>

          <button mat-icon-button color="warn" matTooltip="Eliminar configuración"
                  (click)="remove($index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="cfg-card-row">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="desc-field">
            <mat-label>Descripción</mat-label>
            <input matInput [value]="row.description"
                   (input)="patch($index, 'description', $any($event.target).value)">
          </mat-form-field>
        </div>

        <div class="cfg-card-row">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="multi-field">
            <mat-label>Accesorios</mat-label>
            <mat-select multiple [value]="row.accessories"
                        (selectionChange)="patch($index, 'accessories', $event.value)">
              @for (a of accessoryOptions; track a.id) {
                <mat-option [value]="a.id">{{ accessoryLabel(a) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="multi-field">
            <mat-label>Equipo Periférico</mat-label>
            <mat-select multiple [value]="row.peripheralEquipment"
                        (selectionChange)="patch($index, 'peripheralEquipment', $event.value)">
              @for (p of peripheralOptions; track p.id) {
                <mat-option [value]="p.id">{{ peripheralLabel(p) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="multi-field">
            <mat-label>Tanques de Gas</mat-label>
            <mat-select multiple [value]="row.gasTanks"
                        (selectionChange)="patch($index, 'gasTanks', $event.value)">
              @for (g of gasTankOptions; track g.id) {
                <mat-option [value]="g.id">{{ gasTankLabel(g) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    <button mat-stroked-button color="primary" class="add-btn" (click)="add()">
      <mat-icon>add</mat-icon> Agregar configuración
    </button>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="save()">
      <mat-icon>save</mat-icon>
      <span>Guardar</span>
    </button>
  </mat-dialog-actions>
</div>
